import { render, staticRenderFns } from "./SalesSummery.vue?vue&type=template&id=30520816"
import script from "./SalesSummery.vue?vue&type=script&lang=js"
export * from "./SalesSummery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports